import React, { memo } from 'react';

const Status = memo(({ status }) => {
  return <span className="status-column">{status}</span>;
});

export default Status;
